import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/assortment/')({
  loader: () => {
    redirect({
      to: '/assortment/search',
      throw: true,
    })
  },
  staticData: {
    breadcrumb: 'Sortimentadministrasjon',
  },
})
